import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../Context/Auth";

const PrivateRoutes = ({
  component: Component,
  layout: Layout,
  permission,
  ...rest
}) => {
  const { authTokens } = useAuth();
  let permissionObj = JSON.parse(localStorage?.getItem("userPermissions"));
  let givenPermission;
    if (permissionObj) {
      let singlePermission = Object.keys(permissionObj)
        .filter((key) => key.includes(permission))
        .reduce((cur, key) => {
          return Object.assign(cur, { [key]: permissionObj[key] });
        }, {});
      givenPermission = Object.keys(singlePermission)[0];
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        authTokens && givenPermission ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRoutes;
